import React from 'react'
import AppBar from '@material-ui/core/AppBar'
import IconButton from '@material-ui/core/IconButton'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import MenuIcon from '@material-ui/icons/Menu'
import { getProductName } from 'utils/logoConfig'

const useStyles = makeStyles((theme: Theme) => createStyles({}))
interface IHeader {
  onDrawerOpen: any
}
const Header = (props: IHeader) => {
  const { onDrawerOpen, ...rest } = props
  const classes = useStyles()

  const productName = getProductName()

  return (
    <AppBar {...rest} position="fixed" className="desktop-header">
      <Toolbar>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={onDrawerOpen}
        >
          <MenuIcon />
        </IconButton>
        <Typography
          component="div"
          noWrap
          style={{ color: '#000000ff', fontWeight: 'bold' }}
        >
          {/* <img src={headerLogo} alt="logo" width={150} /> */}
          {productName}
        </Typography>
        {/* <span className="title">IFCA Template</span> */}
      </Toolbar>
    </AppBar>
  )
}
export default Header
